module.exports = __webpack_public_path__ + "static/media/Group39.5cd7170f.svg";